import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  ContainerLoader,
  Table,
  TableHeader,
  TableHeaderCategoryTitle,
  CheckboxTitle,
  TableHeaderTitle,
  Loader,
} from './styles';

import ItemRow from '../item-row';

const TableCategories = (props) => {
  const {
    isLoading,
    isClosedType,
    isAllChecked,
    onSelectOrUnselectAll,
    onSelectOrUnselectItem,
    selectedCategories,
    groupedAnalyticsByCategoryId,
  } = props;

  if (isLoading) {
    return (
      <ContainerLoader>
        <Loader data-loader="table-categories-loader" />
      </ContainerLoader>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableHeaderCategoryTitle>
          {isClosedType ? 'Category' : (
            <CheckboxTitle
              label="Category"
              checked={isAllChecked}
              onChange={onSelectOrUnselectAll}
            />
          )}
        </TableHeaderCategoryTitle>
        <TableHeaderTitle>Card</TableHeaderTitle>
        <TableHeaderTitle>Frequency</TableHeaderTitle>
      </TableHeader>

      {_.map((groupedAnalyticsByCategoryId), (group) => (
        <ItemRow
          key={_.head(group).cardSortCategory.id}
          group={group}
          isClosedType={isClosedType}
          selectOrUnselectItem={onSelectOrUnselectItem}
          selectedCategories={selectedCategories}
        />
      ))}
    </Table>
  );
};

TableCategories.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isClosedType: PropTypes.bool.isRequired,
  isAllChecked: PropTypes.bool.isRequired,
  onSelectOrUnselectAll: PropTypes.func.isRequired,
  onSelectOrUnselectItem: PropTypes.func.isRequired,
  groupedAnalyticsByCategoryId: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedCategories: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.any),
  ).isRequired,
};

export default TableCategories;
